import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import InteriorPaintingPage from '../pages/services/interior-painting/page';
import ElkGroveVillagePage from '../pages/locations/elk-grove-village/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/services/interior-painting', element: <InteriorPaintingPage /> },
  { path: '/locations/elk-grove-village', element: <ElkGroveVillagePage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
